export default function menus(resp) {
    const selectMenus = resp.selectMenus;
    const menuItemMap = resp.menuItemMap;
    const outOfStockLabel = resp.outOfStockLabel;
    const menuList = [];
    if (selectMenus && menuItemMap) {
        selectMenus.forEach(selectMenu => {
            const menu = {
                id: selectMenu.id,
                selectedValueId: selectMenu.selectedValueId,
                items: [],
                error: null,
                displayLabel: selectMenu.displayLabel,
                defaultDisplayValue: selectMenu.defaultDisplayValue,
                outOfStockLabel
            };
            if (selectMenu.menuItemValueIds) {
                selectMenu.menuItemValueIds.forEach(id => {
                    const menuItem = menuItemMap[id.toString()];
                    if (menuItem) {
                        menu.items.push({
                            valueId: menuItem.valueId,
                            isValidForCombo: true,
                            isComboOutOfStock: false,
                            outOfStock: menuItem.outOfStock,
                            displayName: menuItem.displayName
                        });
                    }
                });
            }
            menuList.push(menu);
        });
    }
    return menuList;
}
